/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Set_PasswordInputs */



/**
* | output |
* | --- |
* | "Set your password" |
*
* @param {Auth_Verify_Set_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_set_password = /** @type {((inputs?: Auth_Verify_Set_PasswordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Set_PasswordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Définissez votre mot de passe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Establezca su contraseña")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Defina sua senha")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta la tua password")
	return /** @type {LocalizedString} */ ("Set your password")
});